import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";

import { Action, Category } from "constants/events";
import { useEventTracker } from "hooks/useEventTracker";
import useSearch from "redux/hooks/useSearch";

import Image from "components/Image";

const BrandResults: React.FC = () => {
  const placeholder =
    "https://public.leafly.com/consumer-web/brands/brand-placeholder.svg";
  const ITEMS_PER_LOAD = 8;

  const {
    query: { q, searchCategory },
  } = useRouter();
  const { brand: brands, loadMoreSearchResults } = useSearch();

  const viewingCountOnLoad = searchCategory === "brand" ? 12 : 4;
  const [viewingCount, setViewingCount] = useState(viewingCountOnLoad);

  useEffect(() => {
    setViewingCount(viewingCountOnLoad);
  }, [searchCategory]);

  const { publishEvent } = useEventTracker();

  const handleLoadMore = async () => {
    document.activeElement instanceof HTMLElement &&
      document.activeElement.blur();
    const newViewingCount = ITEMS_PER_LOAD + viewingCount;
    loadMoreSearchResults("brand", newViewingCount);
    publishEvent({
      action: Action.click,
      category: Category.loadMoreBrandResults,
    });
    setViewingCount(newViewingCount);
  };

  if (!brands || !brands.length) {
    return null;
  }

  return (
    <>
      <h2 className="heading--l">Brands</h2>
      <div className="font-normal mb-lg">matching "{q ? String(q) : ""}"</div>
      <div className="row">
        {brands.slice(0, viewingCount).map((brand) => {
          return (
            <div className="col-1/2 md:col-1/3 lg:col-1/4 mb-md" key={brand.id}>
              <a
                data-testid="brand-coin__link"
                href={`/brands/${brand.slug}`}
                onClick={() =>
                  publishEvent({
                    action: Action.click,
                    brandId: brand.id,
                    category: Category.brandResults,
                    label: `brand quick access - ${brand.name}`,
                  })
                }
                className="text-center block p-sm md:p-xs"
              >
                <Image
                  src={brand.logo || placeholder}
                  alt={`${brand.name} result`}
                  sizes={[156]}
                  ratio="square"
                  className="mb-sm object-contain rounded-full elevation-low"
                />
                <span className="text-green">{brand.name}</span>
              </a>
            </div>
          );
        })}
      </div>
      {brands.length >= viewingCount && (
        <button
          className="button mt-lg lg:mt-xl"
          onClick={handleLoadMore}
          data-testid="brand-results-load-more"
        >
          load more brand results
        </button>
      )}
    </>
  );
};

export default BrandResults;
